import { chain } from 'lodash';
import { Acknowledgement } from 'types';

/** Handler to map an array of acks to its acktext */
export const getAckTextListFromAckList = (arr: Acknowledgement[]) =>
  chain(arr)
    .filter(mustHaveAckText)
    .orderBy(a => Number(a.ordinal))
    .map<string>(v => stripHTMLFromAckText(v.ackText))
    .value();

/** Type guard that asserts that an ack *must* have text */
const mustHaveAckText = (ack?: Acknowledgement): ack is AckWithText =>
  !!ack?.ackText;

//see https://msazure.visualstudio.com/One/_workitems/edit/31194432 for reference.  this could be temporary, if the publisher strips them itself instead
const stripHTMLFromAckText = (ackText: string): string => {
  //if this is slow, consider taking the domparser as a parameter and passing a central one to this method from getAckTextListFromAckList
  const doc = new DOMParser().parseFromString(ackText, 'text/html');
  return doc.body.textContent || '';
};

/** Shorthand for an ack that must have text */
type AckWithText = Acknowledgement & Required<Pick<Acknowledgement, 'ackText'>>;
